/**
 * Converts a params object to a query string, stripping null/undefined/empty values.
 * Array values are joined with commas: { status: ["A", "B"] } → status=A%2CB
 */
export function toQueryString(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === "") continue;
    if (Array.isArray(value)) {
      const joined = value.filter((v) => v != null && v !== "").join(",");
      if (joined) searchParams.set(key, joined);
    } else {
      searchParams.set(key, String(value));
    }
  }
  return searchParams.toString();
}
